module.exports = __webpack_public_path__ + "e4227bedad83d59656b442a66e1942bd.ttf";